import { ApiController } from '@/services/ApiController';
import { ApiRoutes } from '@/enums/api/ApiRoutes';
import { AxiosResponse } from 'axios';
import { AddressTypeFields } from '@/interfaces/AddressType';

export default class AddressTypeAPI {
    public static async getAll() {
        let addressTypes;

        try {
            addressTypes = (await ApiController.get(ApiRoutes.addressType.get)) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }

        return Promise.resolve(addressTypes);
    }

    public static async getAllCodes() {
        let codes;

        try {
            codes = (await ApiController.get(ApiRoutes.addressType.getCodes)) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }

        return Promise.resolve(codes);
    }

    public static async getById(addressTypeId: string) {
        let addressType;

        try {
            addressType = (await ApiController.get(ApiRoutes.addressType.getById(addressTypeId))) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }

        return Promise.resolve(addressType);
    }

    public static async update(addressTypeId: string, addressTypeInfo: AddressTypeFields) {
        let addressType;

        const request = {
            data: {
                type: 'address_types',
                id: addressTypeId,
                attributes: {
                    code: addressTypeInfo.code,
                    name: addressTypeInfo.name,
                    info: addressTypeInfo.info,
                    requiredFields: addressTypeInfo.requiredFields,
                    isCompany: addressTypeInfo.isCompany,
                },
            },
        };

        try {
            addressType = (await ApiController.patch(
                ApiRoutes.addressType.update(addressTypeId),
                request,
            )) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }

        return Promise.resolve(addressType);
    }

    public static async create(addressTypeInfo: AddressTypeFields) {
        let addressType;
        const request = {
            data: {
                type: 'address_types',
                attributes: {
                    code: addressTypeInfo.code,
                    name: addressTypeInfo.name,
                    info: addressTypeInfo.info,
                    requiredFields: addressTypeInfo.requiredFields,
                    isCompany: addressTypeInfo.isCompany,
                },
            },
        };

        try {
            addressType = (await ApiController.post(ApiRoutes.addressType.create, request)) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }

        return Promise.resolve(addressType);
    }

    public static async delete(addressTypeId: string) {
        try {
            await ApiController.delete(ApiRoutes.addressType.delete(addressTypeId));
        } catch (e) {
            return Promise.reject(e);
        }

        return Promise.resolve();
    }
}
